module.exports = __webpack_public_path__ + "img/f3.9fa69c07.jpg";